import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import StyledHtmlContent from '../common/StyledHtmlContent';

interface SectionItem {
  title: string;
  description: string;
}

const AboutU888Section: React.FC = () => {
  const { t } = useTranslation();

  const section2Items = t('about.section2.content', { returnObjects: true }) as SectionItem[];
  const section3Items = t('about.section3.content', { returnObjects: true }) as (string | SectionItem)[];
  const section4Items = t('about.section4.content', { returnObjects: true }) as SectionItem[];
  const section5Items = t('about.section5.content', { returnObjects: true }) as SectionItem[];

  return (
    <>
      <Helmet>
        <title>{t('meta.about.title')}</title>
        <meta name="description" content={t('meta.about.description')} />
      </Helmet>
      <section className="bg-[#1a1a1a] text-xl text-white px-4 py-8 mt-[7rem] md:mt-[11rem]">
        {/* Title */}
        <h1 className="text-center text-2xl md:text-3xl font-bold text-[#ff5c00]">
          {t('about.main_title')}
        </h1>

        {/* Intro */}
        <div className="text-center mt-4 max-w-4xl mx-auto leading-relaxed">
          <StyledHtmlContent html={t('about.intro')} />
        </div>

        {/* Image */}
        <div className="w-full max-w-5xl mx-auto mt-10 mb-10 px-4">
          <img
            src="/u888-banner.jpg"
            alt="U888 Promotion"
            className="rounded-md w-full h-auto"
          />
          <label className="block text-center italic mt-2 text-lg">
            {t('home.image_hint')}
          </label>
        </div>
      </section>
    </>
  );
};

export default AboutU888Section; 